import styled from "styled-components";
import { getGlassmorphismStyles } from "../../utils/glassmorphismUtils";
import { CONTRAST_ENUM } from "../../pages/SettingsPage/constants/constants";

interface GlassmorphismContainerProps {
  contrast?: CONTRAST_ENUM;
  justifyContent?: string;
  alignItems?: string;
  padding?: string;
  minHeight?: string;
  height?: string;
  width?: string;
  gap?: string;
  flexDirection?: "row" | "column";
  display?: string;
  boxShadow?: string;
  margin?: string;
  borderRadius?: string;
  hasBorder?: boolean;
  textAlign?: string;
  left?: string;
}

export const GlassmorphismContainer = styled.div<GlassmorphismContainerProps>`
  position: relative;
  ${({ contrast = CONTRAST_ENUM.STANDARD, hasBorder }) => {
    const styles = getGlassmorphismStyles(contrast);
    let border = "none";
    if (hasBorder) {
      switch (contrast) {
        case CONTRAST_ENUM.STANDARD:
          border = styles.border;
          break;
        case CONTRAST_ENUM.WHITE:
          border = "1px solid rgba(34, 64, 77, 0.2)";
          break;
        case CONTRAST_ENUM.DARK:
          border = "1px solid rgba(255, 255, 255, 0.2)";
          break;
        default:
          border = styles.border;
      }
    }
    return `
      background: ${styles.background};
      backdrop-filter: ${styles.backdropFilter};
      -webkit-backdrop-filter: ${styles.webkitBackdropFilter};
      color: ${styles.color};
      border: ${border};
    `;
  }}
  padding: ${({ padding }) => padding || "0"};
  min-height: ${({ minHeight }) => minHeight || "auto"};
  height: ${({ height }) => height || "auto"};
  width: ${({ width }) => width || "auto"};
  gap: ${({ gap }) => gap || "0"};
  flex-direction: ${({ flexDirection }) => flexDirection || "column"};
  display: ${({ display }) => display || "flex"};
  margin: ${({ margin }) => margin || "0"};
  border-radius: ${({ borderRadius }) => borderRadius || "0"};
  justify-content: ${({ justifyContent }) => justifyContent || "flex-start"};
  align-items: ${({ alignItems }) => alignItems || "flex-start"};
  overflow: hidden;
  text-align: ${({ textAlign }) => textAlign || "left"};
  left: ${({ left }) => left || "auto"};
  ${({ contrast = CONTRAST_ENUM.STANDARD }) => {
    if (contrast === CONTRAST_ENUM.STANDARD) {
      return `
        box-shadow: 
          0 8px 32px rgba(0, 0, 0, 0.1),
          inset 0 1px 0 rgba(255, 255, 255, 0.5),
          inset 0 -1px 0 rgba(255, 255, 255, 0.1),
          inset 0 0 24px 12px rgba(255, 255, 255, 0.12);
      `;
    }
    return "";
  }}

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 1px;
    z-index: 0;
    pointer-events: none;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.8),
      transparent
    );
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 1px;
    height: 100%;
    z-index: 0;
    pointer-events: none;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.8),
      transparent,
      rgba(255, 255, 255, 0.3)
    );
  }

  > * {
    position: relative;
    z-index: 1;
  }
`;
